<template>
  <div class="resultstrouble">
    <div class="empty-cart">
      <img
        src="/static/images/icon-info-result.svg"
        alt="Problemas de faturamento"
      >
      <h2>Identificamos problemas de faturamento que estão restringindo seu acesso!</h2>
      <p class="empty-cart__text">
        Por favor, entre em contato com o nosso suporte pelo telefone
        <span>0800 643 8100</span> ou pelo e-mail: <span>cobranca@dasa.com.br</span> para mais informações.
      </p>

      <button
        class="btn md-button btn-primary"
        style="margin-top: 14px; padding: 0 12px"
        @click="returnToDashboard"
      >
        IR PARA DASHBOARD
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResultsTrouble',
  data() {
    return {}
  },
  methods: {
    returnToDashboard() {
      this.$store.commit('RESULT_SET_OVERDUE', false)
      this.$router.replace('/dashboard')
    }
  }
}
</script>

<style lang="scss">
  .resultstrouble {
    .empty-cart {
      img {
        height: 97px;
      }
      h2 {
        width: 70%;
        line-height: 26px;
      }
      &__text {
        width: 64%;
        span {
          font-weight: 500;
        }
      }
    }
  }
</style>
